/**
 * 已出货订单
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { Space, Spin,Tooltip, Badge, Checkbox } from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import dayjs from 'dayjs';
import { toFixedWithCommas} from "@utils/number-util";
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import CustomsClearance from "./customsClearance/CustomsClearance";
import FileManagement from "./FileManagement";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import "./List.less";

class CustomsCoding extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'keyword',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请输入集柜单号或客户编号',
                    cnPlaceholderId:'QingShuRuJiGuiDanHaoHuoKeHuBianHao',
                    type:'SearchInput',
                    width:400,
                },
            ],
            columns:[
                {
                    cnTitle: '集柜单号',
                    dataIndex: 'containerCode',
                    cnTitleId: 'JiGuiDanHao',
                    width:200,
                    render: (containerCode, record) => {
                        return(<>
                            <div className={"flex-item"}>
                                {record.hasRed==1&&<Badge status="error" />}
                                {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}>
                                    <span className={"ml_4 mr_4"}>
                                        <IconDirectPo size={18}></IconDirectPo>
                                    </span>
                                </Tooltip>:null}
                                <span className={"font-bold black89"}>{containerCode}</span>
                            </div>
                            {containerCode&&<div>
                                <LogisticsAndCabinetSwitch poId={record.poId}
                                    poCode={record.poCode}
                                    containerCode={containerCode}
                                    cabinetNum={record.containerNum}
                                    logisticsData={record.pubOrderTrackVOS}
                                    showPoOutInfo={false}  />
                            </div>}
                    </>)}
                },
                {
                    cnTitle: '订单数',
                    cnTitleId: 'DingDanShu',
                    dataIndex: 'orderCount',
                    render:  (num, record, index) => (
                        // hasWarehouseRedPoint 是否有多仓库红点	number	 0:无 1:有
                        record.hasWarehouseRedPoint==1?<Tooltip title={Lang({id:"DangQianJiGuiYouBuTongCangKuDeDingDan",default:"当前集柜有不同仓库的订单"})}>
                            <Badge key={'red'} color={'#F55'} text={num} />
                        </Tooltip>:num
                    )
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuCount}{Lang({id:'Kuan', default:'款'})}, {record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '总体积m³',
                    dataIndex: 'totalVolume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                }, {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    width:250,
                    dataIndex: 'transitCityName',
                    render: (text, record) => <>
                        <p className={"black66"}>{text}</p>
                        {/* isArrive 0:未到达 1:已到达 为1时不显示已过中国边境天数(days)和距离仓库距离描述(lastKilometer)*/}
                        {record.isArrive==1?<p className={"color-green font_12"}>{Lang({id:"YiDaDao",default:"已达到"})}</p>:<>
                            {record.days?<p className={"black45 font_12"}>{Lang({id:"YiGuoZhongGuoBianJingNTian",default:"已过中国边境 {0}天",params:[record.days]})}</p>:null}
                            {/* 距离仓库距离描述 例如:距离仓库 100km */}
                            <p className={"black45 font_12"}> {record.lastKilometer}</p>
                        </>}

                    </>
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'ZhuangGuiFaYunShiJian', default: '装柜发运时间'})}>
                                <i className="ri-truck-line mr_6 black33"></i>{record.deliveryDate ? dayjs(record.deliveryDate).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'YuJiDaoGangShiJian', default: '预计到达时间'})}>
                                <i className="ri-map-pin-line mr_6 color-green"></i>{record.deliveryDate?dayjs(record.deliveryDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                    </> )
                },
                // {
                //     cnTitle: '装柜发运时间',
                //     dataIndex: 'deliveryDate',
                //     cnTitleId: 'ZhuangGuiFaYunShiJian',
                //     render: (deliveryDate, record) => deliveryDate?dayjs(deliveryDate).format('YYYY-MM-DD'):'-'
                // },
                // {
                //     cnTitle: '预计到达时间',
                //     dataIndex: 'arrivalPortDate',
                //     cnTitleId: 'YuJiDaoGangShiJian',
                //     render: (deliveryDate, record) => deliveryDate?dayjs(deliveryDate).format('YYYY-MM-DD'):'-'
                // },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 200,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Space>
                        <CustomsClearance containerId={record.containerId}/>
                        {/*window.location.href=`/shipperManagement/estimatedShippingOrder/bill/${containerId}*/}
                        <AuthBtn icon={"ri-draft-line"} tips = {Lang({id:"DanJuGuanLi",default:"单据管理"})}
                                 linkTo={{
                                     pathname: `/shipperManagement/estimatedShippingOrder/bill/${record.containerId}`,
                                 }}/>
                        <FileManagement id={record.containerId}></FileManagement>
                        <AuthBtn icon={"ri-article-line"} tips = {Lang({id:"XiangQing",default:"详情"})}
                                 linkTo={{
                                     pathname: '/shipperManagement/shippingOrder/detail',
                                     search: `?${record.containerId}`,
                                 }
                                 }/>
                    </Space>)},
            ],
            isTruckingQuery:'',
            totalTrucking:0
        }
    }
    fetchCallBack(res){
        const {success,valid,model} = res;
        if (success && valid) {
            this.setState({
                totalTrucking:model||0
            })
        }else this.setState({
            totalTrucking: 0
        })
    }
    /**
     * 勾选 待确认随车单
     * */
    onChangeSelect(e){
        const {checked}= e.target;
        this.setState({
            isTruckingQuery:checked?1:''
        },()=> {
            this.onPageTemplateTableChild.handleFetch();
        })
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    render(){
        const { loading,searchFormOptions,columns,isTruckingQuery,totalTrucking} = this.state;
        const currPageName = Lang({id: "YiChuHuoJiGui",default: "已出货集柜"});
        //待确认随车单
        const setLeftOne =(<div className={'ml_12'} style={{lineHeight: "32px"}}>
            <Checkbox onChange={(e)=>this.onChangeSelect(e)}>{Lang({id:'DaiQueRenDanJu',default:'待确认单据'})}
            <span className={'color-red ml_4'}>{totalTrucking}</span>
            </Checkbox>
        </div>);
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'shippedOrderWrap'}>
                    <div className={'title fw_700 font_18'}>{currPageName}</div>
                    <AutoFetchTable columns={columns}
                                    onRef={this.onRefTabOne}
                                    flagShowReset={false}
                                    rowKey = 'poId'
                                    fetchCallBack={(res)=>this.fetchCallBack(res)}
                                    topSearchLeftRight={setLeftOne}
                                    precondition={{type:2,isTruckingQuery:isTruckingQuery}} // 列表类型 	1: 预装列表 2:已出货列表
                                    searchFormOptions={searchFormOptions}
                                    fetchApi={'/service/mg/container/list'}
                                    />
                </div>
            </Spin>

        )
    }
}

export default CustomsCoding;
